export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ru": {
        "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Авторизация"])},
        "registration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Регистрация"])}
      },
      "en": {
        "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log in"])},
        "registration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Register"])}
      }
    }
  })
}
